import { Grid, Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { DuplicateIcon, EditIcon, HideIcon, TrashIcon, UnhideIcon } from "../../icon";
import { Plan, TierOccurrence } from "../../models/plans.model";
import ButtonComponent from "../shared/button/button.component";
import { buttonLabels } from "../shared/constants";
import CounterComponent from "../shared/counter.component";
import GridOptions from "../shared/grid-options.component";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";

interface Props {
    openEditPlan?: (plan: Plan, isAddon?: boolean) => void;
    Duplicate?: (plan: Plan, isAddon?: boolean) => void;
    ShowAddOnOptions: boolean;
    OnSelectionChange?: (count: number) => void;
    HideBuyNow?: boolean;
    Index: any;
    SelectionCount?: number;
    MinSelection?: number;
    MaxSelection?: number;
    Plan: Plan;
    PlanSelected: boolean;
    EnableCounter: boolean;
    OpenDisablePlanDialog?: (id: string) => void;
    OpenDeletePlanDialog?: (id: string) => void;
}

const NewAddOnCard: FunctionComponent<Props> = (props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    return (
        <Grid xl={3} lg={3} md={6} sm={8} item className='my-2 mx-1'>
            <div className={`${props.Plan.IsDeleted ? 'plan-card-inactive box-shadow-display-background-shadow' : `plan-card ${props.Index ? "bg-color-primary-light " : "bg-color-secondary"} box-shadow-display-background-shadow`} p-relative my-2 mx-3 o-x-hidden  min-h-25`} >

                <div className={"d-flex justify-between align-center"}>
                    <div className={` ${props.Plan.IsDeleted ? 'color-add-on-text' : props.Index ? "color-secondary" : "color-add-on-text"} ${IsMobileDevice ? 'h1' : 'h2-semibold'} `} >
                        {`$${props.Plan.Price}`}
                    </div>
                    <div className={`add-on-drop-card d-flex w-p-3 t-0 r-5 p-1 p-absolute ${props.Plan.IsDeleted ? 'bg-color-add-on-ribbon-inactive' : props.Index ? "bg-color-secondary" : "bg-color-primary-light"}`}>
                        <div className={`w-space ${!IsMobileDevice ? 'h5-regular my-0 h-8' : 'h5 mr-2 h-6'} ${props.Plan.IsDeleted ? 'color-add-on-ribbon-title-inactive' : props.Index ? "color-primary-light" : "color-secondary"} add-on-text-rotation`}>
                            {props.Plan?.TierOccurrence === TierOccurrence.ONE_TIME ? 'One Time' : 'Recurring'}
                        </div>
                    </div>
                    {props.ShowAddOnOptions &&
                        <div className='p-absolute r-1 t-3'>
                            <GridOptions
                                data={[{
                                    btnName: "Edit",
                                    btnColor: "primary",
                                    onClickbtn: () => { if (props.openEditPlan) { props.openEditPlan(props.Plan, true) } },
                                    btnIcon: EditIcon
                                },
                                {
                                    btnName: props.Plan.IsDeleted ? "Unhide" : "Hide",
                                    btnColor: props.Plan.IsDeleted ? "secondary" : "primary",
                                    onClickbtn: () => { props.OpenDisablePlanDialog(props.Plan.Id) },
                                    btnIcon: props.Plan.IsDeleted ? UnhideIcon : HideIcon
                                },
                                {
                                    btnName: "Duplicate",
                                    btnColor: "primary",
                                    onClickbtn: () => props.Duplicate && props.Duplicate(props.Plan, true),
                                    btnIcon: DuplicateIcon
                                },
                                {
                                    btnName: "Delete", btnColor: "primary",
                                    onClickbtn: () => { props.OpenDeletePlanDialog(props.Plan.Id) },
                                    btnIcon: TrashIcon
                                }]}
                                IsTiers={(props.Index % 2 === 1)}
                                DisabledIcon={props.Plan.IsDeleted}
                            />
                        </div>
                    }
                </div>
                {props.Plan.Features.map(item =>
                    <>
                        <p className={`${props.Plan.IsDeleted ? 'color-add-on-text' : props.Index ? "color-secondary" : "color-add-on-text"} ${IsMobileDevice ? 'h1' : 'h2-semibold w-break'}`}>
                            {props.Plan.Name}
                        </p>
                        <Typography className={`${IsMobileDevice ? 'h4' : 'h5-regular'} ${props.Plan.IsDeleted ? 'color-add-on-text' : props.Index ? "color-secondary" : "color-add-on-text"} mb-2`} key={item.Id}>{item.Label}</Typography>
                        {props.Plan.FootNote &&
                            <div className='t-align-left mt-1'>
                                <Typography className={`${IsMobileDevice ? 'h4' : 'h5-regular'} w-break mb-1 ${props.Plan.IsDeleted ? 'color-primary-accent' : (props.Index % 2 === 1) ? 'color-secondary' : ''} `} gutterBottom>{props.Plan.FootNote}
                                </Typography>
                            </div>
                        }
                    </>
                )}
                {
                    props.HideBuyNow && !props.PlanSelected &&
                    <ButtonComponent
                        OnClick={() => { props.OnSelectionChange(1) }}
                        ButtonLabel={buttonLabels.ADD_PLUS}
                        ClassName={`mx-auto mt-2 br-6   w-p-100 t-align-center justify-center ${IsMobileDevice ? 'h2' : 'h4-regular'} ${!props.PlanSelected && ((props.Index % 2 === 1) ? "add-on-secondary-btn-hover" : "add-on-primary-btn-hover")}`}
                        Variant={(props.Plan.IsDeleted || props.PlanSelected) ? "disabled-btn" : (props.Index % 2 === 1) ? "secondary-btn" : "primary-btn"}
                    />
                }
                {
                    !!props.EnableCounter && <div className='d-flex justify-center'>
                        <CounterComponent
                            inverted={!!props.Index}
                            count={props.SelectionCount || 0}
                            min={props.MinSelection === undefined ? 0 : props.MinSelection}
                            max={props.MaxSelection === undefined ? 25 : props.MaxSelection}
                            onChange={(count) => props.OnSelectionChange(count)}
                            IsMobileDevice={IsMobileDevice}
                        />
                    </div>
                }
            </div>
        </Grid>
    );
}

export default NewAddOnCard;